const USER_DETAILS_STATE_KEY = 'userDetailsState';

export { USER_DETAILS_STATE_KEY };
//# sourceMappingURL=user-details-types.js.map
